import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['backArrow']

  handleBackClick(event) {
    if (!this.hasBackArrowTarget || !this.backArrowTarget.dataset.backEvent) return

    this.dispatch('backButton', { detail: { originalEvent: event } })
  }

  hideLoadingOnBack() {
    this.hideLoading()
  }
}
